// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"123":"fccebedf","364":"4d92aaca","367":"9f79a7c3","388":"07c0e138","463":"7016a404","755":"b2067cb2","801":"89c4bac4"}[chunkId] + ".chunk.js";
};